<template>
  <div class="container work-container">
    <div class="mobile-header">
      <div class="mobile-header-logo-wrapper">
        <router-link to="/" class="not-router-link-active" exact>
          <img src="../../img/b.svg" width="32" height="32" viewBox="0 0 32 32" fill="#fff" />
        </router-link>
      </div>
      <div class="mobile-header-nav">
        <router-link to="/works">works</router-link>
        <router-link to="/about">about</router-link>
      </div>
    </div>
    <div class="display-section">
      <div class="canvas-wrapper" id="deJong-canvas-wrapper">
        <div class="p5-canvas" id="DeJong-canvas"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted () {
    this.initializeP5()
  },
  methods: {
    initializeP5: function () {
      let DeJong = require('@/js/DeJong.js')
      const P5 = require('p5')
      this.p = new P5(DeJong.main)
    }
  }
}
</script>

<style lang="scss">
$xl: 1200px;
$lg: 992px;
$md: 768px;
$sm: 576px;
$conceptColor: #ff4941;

@mixin xl {
  @media (max-width: ($xl)) {
    @content;
  }
}
@mixin lg {
  @media (max-width: ($lg)) {
    @content;
  }
}
@mixin md {
  @media (max-width: ($md)) {
    @content;
  }
}
@mixin sm {
  @media (max-width: ($sm)) {
    @content;
  }
}

.work-container {
  display: flex;
  flex-wrap: wrap;
  @include sm {
    margin-top: 8px;
  }
}
.display-section {
  width: 100%;
  height: 90vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px 32px;
  @include sm {
    padding: 16px 16px;
  }
}
.canvas-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  //   .p5-canvas {
  //     width: 100%;
  //     height: 100%;
  //   }
}
</style>



// WEBPACK FOOTER //
// src/components/Works-items/DeJong.vue